import { NightShiftAvatar, useName } from '@bechtel/client-common';
import { Avatar, AvatarSize, Box, Icon, IconSize, Text } from '@bechtel/gds';
import { CrewMember, CrewMemberShiftType } from '@bechtel/types';
import { FC } from 'react';

export const UserSelectItem: FC<CrewMember> = ({ imageUrl, firstName, lastName, shiftType }) => {
  const { getFullName } = useName();
  return (
    <Box alignItems={{ sm: 'center' }} px={{ sm: '100' }}>
      <Box mr={{ sm: '400' }}>
        {(shiftType === CrewMemberShiftType.NIGHT ?
          (
            <NightShiftAvatar
              data-testid="night-shift-avatar"
              src={imageUrl ?? ''}
            />
          ) : (
            imageUrl ?
              <Avatar
                size={AvatarSize.MEDIUM}
                src={imageUrl ?? ''}
                style={{ borderWidth: '0px' }}
                data-testid="work-owner-photo"
              />
              : (
                <Box
                  mr={{ sm: '100' }}
                  p={{ sm: '300' }}
                  css={`
              background-color: ${({ theme }) => theme.colors.grey[300]};
              border-radius: ${({ theme }) => theme.radii[900]};
            `}
                >
                  <Icon icon="user" fillColor="white" size={IconSize.MEDIUM} iconStyle="solid"></Icon>
                </Box>
              )
          )
        )}
      </Box>
      <Box flexDirection={{ sm: 'column' }}>
        <Text size="400" weight="600" color="grey.1000" data-testid="work-owner-name">
          {getFullName(firstName, lastName)}
        </Text>
      </Box>
    </Box>
  );
};
